// extracted by mini-css-extract-plugin
module.exports = {"popup-wrapper":"PopupContent_popup-wrapper__oHeMe","popup":"PopupContent_popup__u8Zlk","arrow":"PopupContent_arrow__7Biwq"};